// extracted by mini-css-extract-plugin
export default {"card":"MeetingCard_card__dkjkO","header":"MeetingCard_header__D4k7s","roomImg":"MeetingCard_roomImg__5p5Uk","roomDate":"MeetingCard_roomDate__60UUm"};